export const CUSTOMER_TABS = {
  leads: "leads",
  advocates: "advocates",
} as const;

export const CUSTOMER_TABS_LABELS = {
  [CUSTOMER_TABS.leads]: "Leads",
  [CUSTOMER_TABS.advocates]: "Advocates",
} as const;
